import styled from "styled-components";
import { space, layout, SpaceProps, LayoutProps } from "styled-system";
import { FIELD_HEIGHT, fieldFrame, fieldText } from "./fieldStyles";

type InputProps = SpaceProps &
  LayoutProps & {
    /** Show the error state (same as aria-invalid). */
    invalid?: boolean | null;
  };

const Input = styled.input.attrs<InputProps>((props) => ({
  "aria-invalid": props.invalid ? true : props["aria-invalid"],
}))<InputProps>`
  display: block;
  min-height: ${FIELD_HEIGHT}px;
  padding: 7px 12px;
  line-height: 20px;
  max-width: 100%;
  ${fieldFrame(":focus")};
  ${fieldText};
  ${space};
  ${layout};

  &[type="color"] {
    width: 100px;
    height: ${FIELD_HEIGHT}px;
    padding: 3px;
    cursor: pointer;
  }
`;

Input.defaultProps = {
  mb: 0,
  autoComplete: "no",
  width: "100%",
};

export default Input;
